import { EAssetType } from 'constants/enums';

import { UploadFieldConfig } from '../FormFields.types';

export const MAIN_DESIGN_UPLOAD_FIELDS: UploadFieldConfig[] = [
  {
    title: 'Header Image',
    fieldName: 'headerImage',
    forceType: EAssetType.OFFER_HEADER,
    tooltip: 'Upload a horizontal image to display above the calendar.'
  },
  {
    title: 'Collectible Badge Image',
    fieldName: 'collectibleBadgeImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip:
      'Upload a 1:1 icon for the widget where users collect their daily reward.',
    isRequired: true
  },
  {
    title: 'Locked Badge Image',
    fieldName: 'lockedBadgeImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip:
      'Upload a 1:1 icon for the widget where users collect their daily reward.',
    isRequired: true
  }
];

export const SUB_DESIGN_UPLOAD_FIELDS: UploadFieldConfig[] = [
  {
    title: 'Sub Reward Background Image',
    fieldName: 'subRewardBackgroundImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Vertical Image for all sub rewards'
  },
  {
    title: 'Main Rewards Background Image',
    fieldName: 'mainRewardBackgroundImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Horizontal Image to highlight the main reward '
  },
  {
    title: 'Collect Icon Image',
    fieldName: 'collectIconImage',
    forceType: EAssetType.BADGE,
    tooltip: 'Upload a 1:1 icon for previously collected rewards.',
    isRequired: true
  },
  {
    title: 'Locked Icon Image',
    fieldName: 'lockedIconImage',
    forceType: EAssetType.BADGE,
    tooltip: 'Upload a 1:1 icon for rewards locked until their collection day.',
    isRequired: true
  }
];
